import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { CredentialProperties } from './credential-properties';
import { ModelConstants } from '../model-constants';

@Metamodel.model({
    name: ModelConstants.federatedIdentityCredentialProperties,
    display: [shellStringResources.ModelName_FederatedIdentityCredentialProperties]
})
export class FederatedIdentityCredentialProperties extends CredentialProperties {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UamiResourceID
    })
    public resourceId: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Tenant
    })
    public tenant?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ServicePrincipalID
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ServicePrincipalFICSubpath
    })
    public servicePrincipalFmiPath?: string;

    @Metamodel.attribute({
        display: shellStringResources.ServicePrincipalAuthority
    })
    public servicePrincipalAuthority?: string;

    @Metamodel.attribute({
        display: shellStringResources.PrincipalId
    })
    public principalId?: string;
}
